"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseEnv = void 0;
var ReleaseEnv;
(function (ReleaseEnv) {
    ReleaseEnv["STABLE"] = "STABLE";
    ReleaseEnv["PREVIEW"] = "PREVIEW";
})(ReleaseEnv || (exports.ReleaseEnv = ReleaseEnv = {}));
//# sourceMappingURL=index.js.map